<template>
  <!-- eslint-disable max-len -->
  <main class="bg-white u-container">
    <p class="mb-4">
      The Change-of-Address you have filed cannot be processed. Our database classifies the old address as non-residential or business. USPS policy does not allow Individual or Family move types to forward mail from a business or organization to a residential address. If you receive mail addressed to you individually at a business or organization address, please contact the business or organization to redirect your mail. For more information on mail forwarding regulations, contact your local Postmaster.
    </p>
    <button
      ref="exit"
      class="c-btn--secondary mr-5 mb-5 sm:mb-0 m:mb-0 lg:mb-0 xl:mg-0"
      @click="reboot"
    >
      Exit
    </button>
    <router-link
      ref="editAddress"
      :to="editRoute"
      class="c-btn"
    >
      Re-enter Addresses
    </router-link>
  </main>
</template>

<script>
import { isDesktop } from '../utils/deviceType';
import pageView from '../mixins/pageView';

export default {
  name: 'ErrorResidentialBusiness',
  mixins: [pageView],
  computed: {
    editRoute() {
      return { name: !isDesktop() ? 'move-combined' : 'disclaimer' };
    },
  },
  mounted() {
    this.pageView();
  },
  methods: {
    reboot() {
      this.$deleteSession();
      this.$coa.reset();
      this.$router.replace({ name: 'disclaimer' });
    },
  },
};
</script>
